import Lottie from 'lottie-react';
import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthProvider, useAuth } from '@/lib/auth';
import appCompoLoading from '@/assets/animation/loading.json';
import { Button } from '@/components/Elements';
import { Notifications } from '@/components/Notifications/Notifications';
import { queryClient } from '@/lib/react-query';
import 'react-toastify/dist/ReactToastify.css';
import storage from '@/utils/storage';
const ErrorFallback = (a: any) => {
   //console.log('======>>>', a);
  let message=a.error.message;
  let errorCode=undefined;
  if(a.error?.response?.data?.errors&&a.error?.response?.data?.errors.length>0)
  {
    message=a.error?.response?.data?.errors[0].message;
    errorCode=a.error?.response?.data?.errors[0].code;
  }
  if (errorCode==="ERR015"||a.error?.response?.status===401 ) {
    if(a.error?.response?.status===401)
    {
      storage.clearToken();
    }
    //window.location.assign(window.location.origin as unknown as string);
    window.location.href = window.location.origin+'/shops';
    return <div></div>;
  }
  return (
    <div
      className="text-red-500 w-screen h-screen flex flex-col justify-center items-center"
      role="alert"
    >
      <h2 className="text-lg font-semibold">{message} </h2>
      <Button className="mt-4" onClick={() => window.location.reload()}>
        Refresh
      </Button>
    </div>
  );
};

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          <Lottie className="h-60 w-60" animationData={appCompoLoading} />
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
            <Notifications />
            <AuthProvider>
            <Router>{children}</Router>
            <ToastContainer autoClose={2000} />
            </AuthProvider>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
